export default __webpack_public_path__ + "static/media/energetic-eficient-master.fdd693b7.png";